import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [isFocused, setIsFocused] = useState(false);
  const [password, setPassword] = useState('');
  const [isShaking, setIsShaking] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const routeChange = () => {
    const path = `/home`;
    if (password === '1880') {
      navigate(path);
    } else {
      setIsShaking(true);
      setErrorMessage('THE GATES REMAIN CLOSED. WHEN WERE WE BORN?');
      document.querySelector('.login-container').classList.add('darken');
      setTimeout(() => {
        setIsShaking(false);
        setErrorMessage('');
        document.querySelector('.login-container').classList.remove('darken');
      }, 2500);
      setPassword('');
    }
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      routeChange();
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-wrapper">
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <input
          id="userInput"
          type="password"
          placeholder={!isFocused ? 'PASSWORD' : ''}
          className={`login-input ${isShaking ? 'shake' : ''}`}
          value={password}
          onChange={e => setPassword(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyPress={handleKeyPress}
          aria-label="Password input"
          autoComplete="off"
        />
        <button
          onClick={routeChange}
          className="login-button"
          id="myButton"
          aria-label="Enter site"
        >
          ENTER
        </button>
      </div>
    </div>
  );
}

export default Login;
